var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "a-card",
        { attrs: { title: _vm.$t("lbl_warehouse") } },
        [
          _c(
            "a-row",
            { attrs: { gutter: [16, 16] } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c("a-input-search", {
                    staticClass: "w-50 mr-2",
                    attrs: {
                      "allow-clear": "",
                      "enter-button": "",
                      loading: _vm.loading
                    },
                    on: { search: _vm.handleSearch },
                    model: {
                      value: _vm.inputSearch,
                      callback: function($$v) {
                        _vm.inputSearch = $$v
                      },
                      expression: "inputSearch"
                    }
                  }),
                  _c("a-button", {
                    attrs: { icon: "reload", type: "primary" },
                    on: { click: _vm.handleReset }
                  })
                ],
                1
              ),
              _vm.$can("create", "warehouse")
                ? _c(
                    "a-col",
                    { attrs: { span: 12, align: "end" } },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.modal.toggle()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_create_new")) + " ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              "data-source": _vm.dataWarehouse.data,
              columns: _vm.columns,
              loading: _vm.loading,
              "row-key": "id",
              size: "small",
              pagination: {
                showTotal: function() {
                  return _vm.$t("lbl_total_items", {
                    total: _vm.dataWarehouse.totalElements
                  })
                },
                showSizeChanger: true,
                total: _vm.dataWarehouse.totalElements,
                pageSizeOptions: _vm.PAGE_SIZE_OPTIONS,
                current: _vm.pagination.page,
                defaultPageSize: _vm.pagination.limit
              },
              "row-class-name": function(_record, index) {
                return index % 2 ? "bg-white" : "bg-gray-light"
              },
              scroll: { x: 1200 }
            },
            on: { change: _vm.onTableChange },
            scopedSlots: _vm._u(
              [
                {
                  key: "nullable",
                  fn: function(text) {
                    return _c("span", {}, [
                      _vm._v(" " + _vm._s(text || "-") + " ")
                    ])
                  }
                },
                _vm.$can("update", "warehouse")
                  ? {
                      key: "edit",
                      fn: function(text, ref) {
                        var id = ref.id
                        return [
                          _c(
                            "a-button",
                            {
                              attrs: { icon: "edit", type: "link" },
                              on: {
                                click: function($event) {
                                  return _vm.handleEdit(id)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("lbl_edit")) + " ")]
                          )
                        ]
                      }
                    }
                  : null
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _c("FormModals", {
        attrs: {
          visible: _vm.modal.show,
          "warehouse-id": _vm.modal.warehouseId
        },
        on: { close: _vm.handleClose, success: _vm.handleSuccess }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }